import { gql } from "@apollo/client";

export const GET_WEB_FEATURED_INFO = gql`
  {
    Info {
      webFeature {
        type_id
        name
        level
        price
        full_description
      }
    }
  }
`;

export const LICENSING_BY_QAR = gql`
  {
    Info {
      configurations {
        licensing_by_aqar_ar {
          title
          image
          subtitle
          sections {
            title
            bullets
          }
          table {
            headers
            rows
          }
          continue_button_text
          notes
          subscription_button {
            note
            text
            show_button
          }
        }
      }
    }
  }
`;
export const FINANCING_TEXTS = gql`
  {
    Info {
      configurations {
        generic_loan_application
        financing_texts {
          promotional_text {
            ar
            en
          }
          button_text {
            ar
            en
          }
          financing_card_text {
            ar
            en
          }
          financing_card_sub_text {
            ar
            en
          }
          financing_card_button {
            ar
            en
          }
        }
        rnpl_enabled
      }
    }
  }
`;
export const GET_CALCULATIONS = gql`
  query getCalculation(
    $land_area: Float!
    $floors_type: FloorsType!
    $basement_area: Float
  ) {
    HomePlans {
      buildingCalculator(
        land_area: $land_area
        floors_type: $floors_type
        basement_area: $basement_area
      ) {
        ground_floor_area
        first_floor_area
        roof_floor_area
        surface_area
        swimming_pool
        fence
        water_tank
        drainage_tank
        structural_concrete_cost
        finishing_costs
        turnkey_costs
      }
    }
  }
`;

export const GET_CONTACT_US_OPTIONS = gql`
  query {
    Info {
      contact_us_options {
        support {
          key
          user_id
          ar
          en
        }
        contact {
          key
          user_id
          ar
          en
        }
      }
    }
  }
`;
export const GET_GENERIC_BANNER = gql`
  query {
    Info {
      configurations {
        generic_banner
      }
    }
  }
`;

export const GET_MLR_NON_ELEC_CONFIG = gql`
  query GetMlrNonElecConfig {
    Info {
      mlr_non_electronic_deed_configurations
    }
  }
`;

export const GET_EJAR_CONFIG_TXT = gql`
  query getEjarConfig {
    Info {
      configurations {
        ejar_by_kevel_info {
          ar
          en
        }
      }
    }
  }
`;

export const GET_DAILY_RENT_GUARANTEE_CONFIG = gql`
  query getEjarConfig {
    Info {
      configurations {
        show_daily_rent_guarantee_box
      }
    }
  }
`;

export const GET_KEVEL_OPTIONS = gql`
  query getKevelOptions {
    Info {
      configurations {
        kevel_options
      }
    }
  }
`;

export const GET_SUB_GENERAL_NOTE = gql`
  query getSubGeneralNote {
    Info {
      configurations {
        sub_general_note {
          ar
          en
        }
      }
    }
  }
`;

export const GET_SUB_FAQS = gql`
  query getSubFaqs {
    Info {
      configurations {
        sub_faqs {
          question {
            ar
            en
          }
          answer {
            ar
            en
          }
        }
      }
    }
  }
`;
